module.exports = __webpack_public_path__ + "img/pieceOneImg4.3c7b1ca.png";